import { pickAnchor } from "@/lib/seo/anchor-rotator";

export type RelatedLink = {
  /** Absolute or app-relative path, e.g. "/gold-rate-karachi". */
  to: string;
  /** 3–5 anchor-text variants; one is picked deterministically per source page. */
  variants: string[];
};

/**
 * RelatedQueries — 8–12 internal links with deterministic rotated anchor text.
 * Helps Google build a natural link-graph for the target pages
 * (no two source pages link with the SAME phrase to the same target).
 */
export function RelatedQueries({
  sourcePath,
  links,
  title = "Related guides",
}: {
  sourcePath: string;
  links: RelatedLink[];
  title?: string;
}) {
  if (links.length === 0) return null;
  return (
    <nav
      aria-label={title}
      className="mx-auto max-w-6xl px-4 pb-10"
    >
      <h2 className="mb-3 text-base font-semibold text-foreground md:text-lg">
        {title}
      </h2>
      <ul className="grid gap-2 sm:grid-cols-2 md:grid-cols-3">
        {links.map((l) => {
          const anchor = pickAnchor(sourcePath, l.to, l.variants);
          return (
            <li key={l.to}>
              <a
                href={l.to}
                className="block rounded-lg border border-border bg-card px-3 py-2 text-sm text-foreground transition-colors hover:border-primary hover:text-primary"
              >
                {anchor}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}